interface ContentBodyListProps {
  header?: string;
  title?: string | JSX.Element;
  itemList?: string[] | undefined;
  info?: string | JSX.Element;
}

export const ContentBodyList: React.FC<ContentBodyListProps> = ({
  header,
  title,
  itemList,
  info,
}) => {
  return (
    <>
      {header && <h3>{header}</h3>}
      {title && <p>{title}</p>}
      {itemList !== undefined && itemList.length > 0 ? (
        <ul className="list-disc">
          {itemList.map((item, index) => (
            <li key={`${item}_${index}`} className="ml-6">
              {item}
            </li>
          ))}
        </ul>
      ) : null}
      {info && <p>{info}</p>}
    </>
  );
};
//condition ? <ConditionalComponent /> : null;
